  class CustomScrollbar {
    constructor(wrapper, classMap) {
      this.wrapper = wrapper;
      this.classes = classMap;

      this.scrollContent = wrapper.querySelector(this.classes.content);
      this.track = wrapper.querySelector(this.classes.track);
      this.thumb = wrapper.querySelector(this.classes.thumb);

      this.isDragging = false;
      this.startX = 0;
      this.startLeft = 0;
      this.scrollAnimationFrame = null;

      this.init();
    }

    init() {
      this.updateThumbWidth();
      this.updateThumbPosition();
      this.addEventListeners();
    }

    updateThumbWidth() {
      const ratio = this.scrollContent.clientWidth / this.scrollContent.scrollWidth;
      const newWidth = Math.max(30, this.track.clientWidth * ratio);
      this.thumb.style.width = `${newWidth}px`;
    }

    updateThumbPosition() {
      if (this.isDragging) return; // Avoid flicker during drag
      cancelAnimationFrame(this.scrollAnimationFrame);
      this.scrollAnimationFrame = requestAnimationFrame(() => {
        const scrollLeft = this.scrollContent.scrollLeft;
        const scrollWidth = this.scrollContent.scrollWidth;
        const clientWidth = this.scrollContent.clientWidth;
        const maxLeft = this.track.clientWidth - this.thumb.offsetWidth;

        const ratio = scrollLeft / (scrollWidth - clientWidth);
        this.thumb.style.left = `${ratio * maxLeft}px`;
      });
    }

    onScroll = () => {
      this.updateThumbPosition();
    };

    onMouseDown = (e) => {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startLeft = this.thumb.offsetLeft;
      document.body.style.userSelect = 'none';
    };

    onMouseMove = (e) => {
      if (!this.isDragging) return;

      const dx = e.clientX - this.startX;
      const maxLeft = this.track.clientWidth - this.thumb.offsetWidth;
      const newLeft = Math.min(Math.max(0, this.startLeft + dx), maxLeft);
      this.thumb.style.left = `${newLeft}px`;

      const ratio = newLeft / maxLeft;
      const newScrollLeft = ratio * (this.scrollContent.scrollWidth - this.scrollContent.clientWidth);
      this.scrollContent.scrollLeft = newScrollLeft;
    };

    onMouseUp = () => {
      if (this.isDragging) {
        this.isDragging = false;
        document.body.style.userSelect = '';
        this.updateThumbPosition(); // Sync after drag
      }
    };

    onResize = () => {
      this.updateThumbWidth();
      this.updateThumbPosition();
    };

    addEventListeners() {
      this.scrollContent.addEventListener('scroll', this.onScroll);
      this.thumb.addEventListener('mousedown', this.onMouseDown);
      window.addEventListener('resize', this.onResize);
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    }
  }

  (function () {
    const classMap = {
      content: '.slider-content',
      track: '.custom-scrollbar',
      thumb: '.custom-thumb'
    };

    document.querySelectorAll('.slider-wrapper').forEach(wrapper => {
      new CustomScrollbar(wrapper, classMap);
    });
  })();
